module.exports = __webpack_public_path__ + "img/hr-brown-carpet-grass-09.93111e37.png";